import { render } from "./_Index.vue?vue&type=template&id=f29ffc06&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=f29ffc06&scoped=true&lang=css"
import "./_Index.vue?vue&type=style&index=1&id=f29ffc06&lang=css"
script.render = render
script.__scopeId = "data-v-f29ffc06"

export default script